import { memo } from 'react';
import { IconWrapper } from './IconWrapper';

export const CaretRightIcon = memo(() => (
    <IconWrapper>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path fill="currentColor" d="m8.25 6 7.5 6-7.5 6V6Z"/>
        </svg>
    </IconWrapper>
));
